import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { needsDecision, setConsent, onConsentChange } from '../lib/consent';
import './CookieConsent.css';

/**
 * Analytics consent banner.
 *
 * Deliberately offers exactly two actions, styled at equal weight. There is no
 * dismiss affordance: closing a banner is not a decision, and treating silence
 * as agreement is the specific pattern EU regulators have repeatedly ruled
 * against. Until one of the two buttons is pressed, `hasConsent()` stays false
 * and PostHog is never initialised.
 */
const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(needsDecision());
    // "Cookie settings" elsewhere in the app calls resetConsent(), which fires
    // this event with a null state — that has to bring the banner back. A
    // decision synced from another tab or developers.coinversa.ai arrives the
    // same way, so the banner closes (or reopens) there too.
    return onConsentChange((e) => setOpen(!e.detail || e.detail.state == null));
  }, []);

  if (!open) return null;

  const choose = (value) => () => {
    setConsent(value, { surface: 'banner' });
    setOpen(false);
  };

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-live="polite"
      aria-label="Analytics cookies"
    >
      <div className="cookie-consent-inner">
        <div className="cookie-consent-copy">
          <p className="cookie-consent-title">Analytics cookies</p>
          <p className="cookie-consent-text">
            We use cookies to understand how the site is used, they recognize you across <i>coinversa.ai</i> and <i>developers.coinversa.ai</i>.
            <br />
            Cookies are opt-in and you can change your mind at any time
            by clicking on Cookie settings in the footer.{' '}
            <Link to="/privacy">Read the Privacy Policy</Link>.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button type="button" className="cookie-consent-btn" onClick={choose('granted')}>
            <u>Accept</u>
          </button>
          <button type="button" className="cookie-consent-btn" onClick={choose('denied')}>
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
